/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sync-rotated': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M19 8l-4 4h3a6 6 0 01-6 6c-1 0-1.97-.25-2.8-.7l-1.46 1.46A7.93 7.93 0 0012 20a8 8 0 008-8h3M6 12a6 6 0 016-6c1 0 1.97.25 2.8.7l1.46-1.46A7.93 7.93 0 0012 4a8 8 0 00-8 8H1l4 4 4-4"/>'
  }
})
